import { ReactElement } from 'react'
import { Spacer } from '~/components/Common/Spacer'

interface SidebarListSubitemProps {
    /**
     * List item text
     */
    children: string
    /**
     * List item badge
     */
    badge?: JSX.Element
    /**
     * List item active state
     */
    active?: boolean
    /**
     * Optional click event
     */
    onClick?: () => void
    /**
     * Is header
     */
    isHeader?: boolean
}

export const SidebarListSubitem = ({
    children,
    badge,
    active = false,
    onClick,
    isHeader = false
}: SidebarListSubitemProps): ReactElement => {
    const handleClick = () => {
        if (!onClick) {
            return
        }

        onClick()
    }

    return (
        <li data-testid="sidebar_list_subitem_component">
            <a
                className={`flex ${isHeader ? 'pl-4 rtl:pl-1 rtl:pr-4 bg-gray-100 cursor-default' : 'pl-11 rtl:pl-1 rtl:pr-11 cursor-pointer hover:bg-[#FF52001A]'
                    } py-1.5 text-sm items-center px-1 font-medium rounded-lg ${active ? 'text-[#FF5200]' : 'text-neutrals-800'
                    }`}
                role="button"
                onClick={() => !isHeader && handleClick()}
                data-testid="sidebar_list_subitem_component_button">
                <span>{children}</span>
                <Spacer></Spacer>
                {!!badge && <span className="mr-1 rtl:mr-0 rtl:ml-1">{badge}</span>}
            </a>
        </li>
    )
}
